module.exports = __webpack_public_path__ + "static/media/alarm1.3005ac6c.svg";